module.exports = __webpack_public_path__ + "img/acsw_full-01.8cc936ca.jpg";